import { render, staticRenderFns } from "./BuyerOrderCollection.vue?vue&type=template&id=25670926&"
import script from "./BuyerOrderCollection.vue?vue&type=script&lang=js&"
export * from "./BuyerOrderCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports